;(function () {
  String.prototype.camelize = function () {
    return this.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) {
        return ""
      }
      if (index === 0) {
        return match.toLowerCase()
      } else {
        return match.toUpperCase()
      }
    })
  }

  $.fn.findIncludingSelf = function (selector) {
    return this.filter(selector).add(this.find(selector))
  }
}).call(this)
